<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col-12">
        <h1>Politique de confidentialité</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-4">
        Cette page explique quelles données personnelles Lettre Compte Triple collecte,
        pourquoi, combien de temps elles sont conservées et comment exercer vos droits,
        conformément au Règlement général sur la protection des données (RGPD) et à la
        loi Informatique et Libertés.
      </div>

      <div class="col-12 mt-4">
        <h4>Responsable du traitement</h4>
        GOURIO CONSULTING, SAS – RCS Bobigny 892 585 225<br />
        14 rue Auber<br />
        75009 Paris<br />
        E-mail : <a href="mailto:sylvain@lettrecomptetriple.org">sylvain@lettrecomptetriple.org</a>
      </div>

      <div class="col-12 mt-4">
        <h4>Données collectées et finalités</h4>
        <ul>
          <li>
            <strong>Compte joueur</strong> : lors de la connexion avec Google ou Facebook,
            nous recevons votre identifiant, votre nom et votre adresse e-mail. Nous y ajoutons
            le pseudo et la photo de profil que vous choisissez. Ces données servent à créer
            et gérer votre compte (base légale : exécution du service).
          </li>
          <li>
            <strong>Activité de jeu</strong> : parties jouées, scores, classement et messages
            échangés dans le chat des parties. Ces données servent au fonctionnement du jeu,
            au classement et à la modération (base légale : exécution du service).
            Votre pseudo, votre photo, vos statistiques et votre classement sont visibles
            par les autres joueurs.
          </li>
          <li>
            <strong>Formulaire de contact</strong> : le contenu de votre message et votre
            identité de joueur, afin de vous répondre (base légale : intérêt légitime).
          </li>
          <li>
            <strong>Soutien financier</strong> : les paiements sont traités par Stripe.
            Vos coordonnées bancaires sont saisies directement chez Stripe et ne sont jamais
            stockées par Lettre Compte Triple. Nous conservons uniquement la trace du paiement
            et le statut premium associé à votre compte (base légale : exécution du contrat
            et obligations comptables).
          </li>
          <li>
            <strong>Mesure d'audience et publicité</strong> : avec votre consentement, des
            cookies tiers sont utilisés pour mesurer la fréquentation du site et afficher
            des publicités (voir la section Cookies).
          </li>
        </ul>
      </div>

      <div class="col-12 mt-4">
        <h4>Durée de conservation</h4>
        <ul>
          <li>Données du compte et activité de jeu : tant que le compte est actif, puis
            3 ans après la dernière connexion.</li>
          <li>Messages de contact : 3 ans après le dernier échange.</li>
          <li>Données de paiement : 10 ans, au titre des obligations comptables.</li>
          <li>Cookies : 13 mois maximum.</li>
        </ul>
      </div>

      <div class="col-12 mt-4">
        <h4>Destinataires et sous-traitants</h4>
        Vos données ne sont jamais vendues. Elles sont uniquement accessibles à l'équipe
        de Lettre Compte Triple et aux prestataires suivants :
        <ul>
          <li>Amazon Web Services (hébergement, authentification) – serveurs situés en
            Irlande (Union européenne) ;</li>
          <li>Google et Facebook (connexion à votre compte) ;</li>
          <li>Stripe (paiement) ;</li>
          <li>Google (Tag Manager, Google Ads, AdSense) et Facebook (mesure d'audience
            et publicité) ;</li>
          <li>Prismic (hébergement des articles du site).</li>
        </ul>
        Certains de ces prestataires peuvent transférer des données hors de l'Union
        européenne, notamment vers les États-Unis. Ces transferts sont encadrés par le
        cadre de protection des données UE–États-Unis (Data Privacy Framework) ou par
        les clauses contractuelles types de la Commission européenne.
      </div>

      <div class="col-12 mt-4">
        <h4>Cookies</h4>
        <ul>
          <li>
            <strong>Stockage nécessaire au fonctionnement</strong> : les informations de
            session (jetons de connexion) sont conservées dans le stockage de session de
            votre navigateur et supprimées à sa fermeture. Elles ne nécessitent pas votre
            consentement.
          </li>
          <li>
            <strong>Cookies de mesure d'audience et de publicité</strong> : Google Tag Manager,
            Google Ads, Google AdSense et le SDK Facebook peuvent déposer des cookies pour
            mesurer la fréquentation et personnaliser les publicités. Ils ne sont déposés
            qu'avec votre consentement, que vous pouvez retirer à tout moment.
          </li>
        </ul>
        Vous pouvez également configurer votre navigateur pour refuser les cookies.
      </div>

      <div class="col-12 mt-4">
        <h4>Vos droits</h4>
        Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation,
        de portabilité et d'opposition sur vos données, ainsi que du droit de retirer votre
        consentement à tout moment. Vous pouvez aussi définir des directives sur le sort de
        vos données après votre décès.<br />
        Pour exercer ces droits, écrivez à
        <a href="mailto:sylvain@lettrecomptetriple.org">sylvain@lettrecomptetriple.org</a>,
        utilisez la page <router-link to="/contact">Contact</router-link> (une fois connecté)
        ou écrivez à l'adresse postale indiquée ci-dessus.<br />
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez adresser une
        réclamation à la CNIL (<a href="https://www.cnil.fr" target="_blank"
        rel="noopener">www.cnil.fr</a>).
      </div>

      <div class="col-12 mt-4 mb-4">
        <h4>Modifications</h4>
        Cette politique peut être mise à jour. La date de dernière mise à jour est indiquée
        ci-dessous.<br />
        Dernière mise à jour : 11 octobre 2026.
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from './LoggedUser.vue';
import BottomNav from './BottomNav.vue';

export default {
  name: 'PolitiqueConfidentialite',
  components: { LoggedUser, BottomNav },
};
</script>

<style scoped>

</style>
